import { Ripples } from "assets/svg"
import classNames from "classnames"
import { motion } from "framer-motion"

const AudioRipple = ({ volumeLevel = 0 }) => {
    const scaleVal = Math.min(1.5, 1 + (0.005 * volumeLevel))
    const opacityVal = 1.4 - ((2 * scaleVal) - 1.7)
    return (
        <motion.div
            initial={{ scale: 1, opacity: 1 }}
            animate={{ scale: scaleVal, opacity: opacityVal }}
            className={classNames("absolute top-[-50px] left-[calc(50%-168px)] sm:left-[calc(50%-168px)] w-[90vw] sm:w-[330px] h-[180px] overflow-hidden")}>
            <span className="absolute top-[-100px] left-[-26px]">
                <Ripples />
            </span>
        </motion.div>
    )
}

export default AudioRipple
